function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_487_",
  d: "m386.132 0h-260.264c-26.068 0-47.277 21.208-47.277 47.276v417.447c0 26.069 21.209 47.277 47.277 47.277h260.264c26.068 0 47.277-21.208 47.277-47.276v-417.448c0-26.068-21.209-47.276-47.277-47.276zm17.277 464.724c0 9.526-7.75 17.276-17.277 17.276h-260.264c-9.526 0-17.277-7.75-17.277-17.276v-417.448c0-9.526 7.75-17.276 17.277-17.276h260.264c9.526 0 17.277 7.75 17.277 17.276z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_486_",
  d: "m295.156 59.136h-78.312c-34.322 0-62.245 27.924-62.245 62.246v43.302c0 34.322 27.923 62.245 62.245 62.245h78.312c34.322 0 62.245-27.923 62.245-62.245v-43.302c0-34.322-27.923-62.246-62.245-62.246zm32.245 105.548c0 17.78-14.465 32.245-32.245 32.245h-78.312c-17.78 0-32.245-14.465-32.245-32.245v-43.302c0-17.78 14.465-32.246 32.245-32.246h78.312c17.78 0 32.245 14.466 32.245 32.246z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_485_",
  d: "m219.563 102.057c-8.284 0-15 6.716-15 15v26.54c0 8.284 6.716 15 15 15s15-6.716 15-15v-26.54c0-8.285-6.716-15-15-15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_484_",
  d: "m292.437 102.057c-8.284 0-15 6.716-15 15v26.54c0 8.284 6.716 15 15 15s15-6.716 15-15v-26.54c0-8.285-6.716-15-15-15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_483_",
  d: "m256 155.467c-8.284 0-15 6.716-15 15v4.871c0 8.284 6.716 15 15 15s15-6.716 15-15v-4.871c0-8.284-6.716-15-15-15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_482_",
  d: "m295.156 285.071h-78.312c-34.322 0-62.245 27.923-62.245 62.245v43.302c0 34.322 27.923 62.246 62.245 62.246h78.312c34.322 0 62.245-27.924 62.245-62.246v-43.302c0-34.322-27.923-62.245-62.245-62.245zm32.245 105.547c0 17.78-14.465 32.246-32.245 32.246h-78.312c-17.78 0-32.245-14.466-32.245-32.246v-43.302c0-17.78 14.465-32.245 32.245-32.245h78.312c17.78 0 32.245 14.465 32.245 32.245z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_481_",
  d: "m219.563 327.992c-8.284 0-15 6.716-15 15v26.54c0 8.284 6.716 15 15 15s15-6.716 15-15v-26.54c0-8.284-6.716-15-15-15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_480_",
  d: "m292.437 327.992c-8.284 0-15 6.716-15 15v26.54c0 8.284 6.716 15 15 15s15-6.716 15-15v-26.54c0-8.284-6.716-15-15-15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_479_",
  d: "m256 381.402c-8.284 0-15 6.716-15 15v4.87c0 8.284 6.716 15 15 15s15-6.716 15-15v-4.87c0-8.284-6.716-15-15-15z"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "XMLID_478_",
  cx: 256,
  cy: 256,
  rx: 15,
  ry: 15.02
}));

function Svg26(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg26);
export default __webpack_public_path__ + "static/media/2_6.5b49c1b7.svg";
export { ForwardRef as ReactComponent };